export default {
  title: 'تعطيل الوصول إلى منصة',
  subtitle: 'يمكنك تعطيل وصول مستخدم إلى منصة',
  searchLabel: 'بحث',
  disableAccess: 'تعطيل الوصول إلى',
  qDialog: {
    title: 'تأكيد مطلوب',
    subtitle: 'تعطيل الوصول إلى هذه المنصة',
    content: 'هل أنت متأكد أنك تريد تعطيل الوصول إلى {platformDisable} لـ '
  },
  noUser: 'لم يتم العثور على أي مستخدم',
  listOfUsersTable: {
    name: 'الاسم الأول، الاسم الأخير',
    email: 'عنوان البريد الإلكتروني',
    type: 'النوع',
    access: 'الوصول'
  }
}
